import { action, computed, makeObservable, observable } from 'mobx';
import { applicationStore } from '@pascal/pascal-core/shared/core/store';

class WinningStore {
  winningAmount = null;

  demoWinningAmount = null;

  winCombination = null;

  lastWinAmount = 0;

  gambleWin = 0;

  constructor() {
    makeObservable(this, {
      winningAmount: observable,
      lastWinAmount: observable,
      demoWinningAmount: observable,
      winCombination: observable,
      gambleWin: observable,
      setWinningAmount: action.bound,
      setWinCombination: action.bound,
      clearWinInfo: action.bound,
      setLastWin: action.bound,
      setGambleWin: action.bound,
      winningAmountByMode: computed,
    });
  }

  get winningAmountByMode() {
    if (applicationStore.isDemo) {
      return this.demoWinningAmount;
    }
    return this.winningAmount;
  }

  setWinningAmount(winningAmount, isDemo) {
    if (isDemo) {
      this.demoWinningAmount = winningAmount;
    } else {
      this.winningAmount = winningAmount;
    }
  }

  setWinCombination(winType) {
    this.winCombination = winType;
  }

  setLastWin(win) {
    this.lastWinAmount = win;
  }

  setGambleWin(win) {
    this.gambleWin = win;
  }

  clearWinInfo() {
    this.gambleWin = null;
    this.winningAmount = null;
    this.demoWinningAmount = null;
  }
}

export const winningStore = new WinningStore();
